import { call, put } from 'redux-saga/effects';
import GetMeActions from '../redux/GetMeRedux';
import { api } from './api';


export function* getMe(action: any): Generator<any, void, any> {
  const { accessToken, navigate } = action;
  console.log('GetMe Saga: Starting with accessToken:', accessToken ? 'Found' : 'Missing');

  // Set the user token for authentication
  if (accessToken) {
    api.setUserToken(accessToken);
  }
  
  const response = yield call(api.getMe);
  console.log('GetMe Saga: API response:', response);

  // success?
  if (response.ok) {
    console.log('GetMe Saga: API call successful, response data:', response.data);
    
    // Extract the required fields from response.data
    const { status, locale, settings } = response.data;
    console.log('GetMe Saga: Extracted data:', { status, locale, settings });
    
    // Pass the individual fields as expected by the reducer
    yield put(GetMeActions.getMeSuccess(status, locale, settings));
  } else {
    console.error('GetMe Saga: API call failed:', response);
    if (response.status === 401 && navigate) {
      // redirect to tutorial page
      navigate('/tutorial');
    }
    yield put(GetMeActions.getMeFailure());
  }
}